import { Component, OnInit } from "@angular/core";
import { AnnouncementService } from "../../app/shared/services/announcement.service";

@Component({
    selector: "global-announcement",
    templateUrl: "./announcement.component.html",
    styleUrls: ["./announcement.component.css"],
    standalone: false
})
export class AnnouncementComponent implements OnInit {
    constructor(private announcementService: AnnouncementService) {}
    annoucement: any = {
        active: false,
        message: "",
    };

    get() {
        this.announcementService.get().subscribe({
            next: (result) => {
                this.annoucement = result;
            },
            error: (err) => {
                //no actio
            },
        });
    }

    ngOnInit() {
        this.get();
    }
}
